class PatientRecallsItem {
    public RecallId: string;
    public Type: string;
    public DueDate: string;
    public Notes: string;
    public Priority: string;
    public Specialization: string;
    public CreatedBy: string;
    public To: string;
    public IsCompleted: boolean;
}

export { PatientRecallsItem };
